import React from 'react';
import { useStore } from 'effector-react';
import type { HSIconImage, HSIconSeqFrame, HSIconVideo } from '@types';
import Button from '@components/Button';
import {
  $editingHotspot,
  $editingHotspotApi,
} from '@stores/editingHotspotStores';
import ImageMoveRow from '../ImageMoveRow';
import ImageScaleRow from '../ImageScaleRow';
import hotspotIconDefault from '../../utils/hotspotIconDefault';
import { reAddEditingHotspot } from '../../actions';

type Icon = HSIconImage | HSIconSeqFrame | HSIconVideo;

function ManualControl() {
  const { hotspot } = useStore($editingHotspot)!;
  const { type } = hotspot.icon as Icon;

  const handleReset = () => {
    const data = hotspotIconDefault({ type }) as Icon;
    $editingHotspotApi.update((draft) => {
      const icon = draft.icon as Icon;
      icon.edge = data.edge;
      icon.scaleX = data.scaleX;
      icon.scaleY = data.scaleY;
      icon.rx = data.rx;
      icon.ry = data.ry;
      icon.rz = data.rz;
      icon.positionType = data.positionType;
      icon.hFov = undefined;
      icon.yaw = undefined;
      icon.pitch = undefined;
      icon.roll = undefined;
    });
    reAddEditingHotspot();
  };

  return (
    <>
      <ImageMoveRow />
      <ImageScaleRow />
      <Button className="w-full" onClick={handleReset}>
        重置设置
      </Button>
    </>
  );
}

export default ManualControl;
